export { default as ElementInspector } from "./ElementInspector";
export type { ElementInfo } from "./ElementInspectorItem";
